var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container",attrs:{"id":"app"}},[_c('md-app',[_c('md-app-toolbar',{staticClass:"md-primary"},[_c('span',{staticClass:"md-title"},[_vm._v("MineChat.Design")])]),_c('md-app-content',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }